import React, { useEffect, useState } from 'react';
import { RadioIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'glass-panel border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-84">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-85">
        <div className="flex items-center gap-2" data-id="element-86">
          <RadioIcon className="w-6 h-6 text-stream-500" data-id="element-87" />
          <span className="font-mono font-bold text-xl tracking-tight text-white" data-id="element-88">
            ORION<span className="text-stream-500" data-id="element-89">ARENA</span>
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-90">
          <a href="#services" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-91">
            Services
          </a>
          <a href="#pricing" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-92">
            Pricing
          </a>
          <a href="#team" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-93">
            Team
          </a>
          <button className="px-5 py-2.5 bg-stream-600 hover:bg-stream-500 text-white text-sm font-semibold rounded-md transition-all animate-glow shadow-[0_0_15px_rgba(168,85,247,0.3)]" data-id="element-94">
            Go Live
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-400 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-95">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-96" /> : <MenuIcon className="w-6 h-6" data-id="element-97" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 glass-panel border-b border-white/5 p-6 flex flex-col gap-4" data-id="element-98">
          <a href="#services" className="text-sm font-medium text-gray-300 hover:text-white" onClick={() => setMobileMenuOpen(false)} data-id="element-99">
            Services
          </a>
          <a href="#pricing" className="text-sm font-medium text-gray-300 hover:text-white" onClick={() => setMobileMenuOpen(false)} data-id="element-100">
            Pricing
          </a>
          <a href="#team" className="text-sm font-medium text-gray-300 hover:text-white" onClick={() => setMobileMenuOpen(false)} data-id="element-101">
            Team
          </a>
          <button className="w-full px-5 py-3 mt-2 bg-stream-600 text-white text-sm font-semibold rounded-md" data-id="element-102">
            Go Live
          </button>
        </div>}
    </nav>;
}